import { Fragment, useEffect, useState } from 'react'
import { Container } from '@/components/container'
import {
    Toolbar,
    ToolbarActions,
    ToolbarDescription,
    ToolbarHeading,
    ToolbarPageTitle,
} from '@/partials/toolbar'
import { PageNavbar } from '@/pages/account'
import { DomainActivityContent } from './DomainActivityContent'
import axios from 'axios'
import { enqueueSnackbar } from 'notistack'
import {DomainActivityData} from "@/pages/buddy/types/DomainActivity.ts";

export const DomainActivityPage: React.FC = () => {
    const [data, setData] = useState<DomainActivityData[]>([])
    const [loading, setLoading] = useState(true)

    const API = `${import.meta.env.VITE_APP_API_URL}/admin/domain-activity`

    useEffect(() => {
        setLoading(true)
        axios
            .get<DomainActivityData[]>(API, { headers: { Accept: 'application/json' } })
            .then(res => setData(res.data))
            .catch(err => {
                enqueueSnackbar(`Failed to load domain activity: ${err}`, {
                    variant: 'solid',
                    state: 'danger',
                })
            })
            .finally(() => setLoading(false))
    }, [])

    return (
        <Fragment>
            <PageNavbar />

            <Container>
                <Toolbar>
                    <ToolbarHeading>
                        <ToolbarPageTitle/>
                        <ToolbarDescription>
                            See counts of companies, jobs, candidates and matches per domain,
                            plus the users in each domain.
                        </ToolbarDescription>
                    </ToolbarHeading>
                </Toolbar>
            </Container>

            <Container>
                <DomainActivityContent data={data} loading={loading} />
            </Container>
        </Fragment>
    )
}
